module.exports = {
  "slide-nav": {
    "position": "absolute",
    "zIndex": 1000
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-572f0ab8!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-slide-nav/index.vue
// module id = 478
// module chunks = 0 1